import { ajax } from '@/api/ajax'

//1、教学问卷分页
export const reqQuesList = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/list`, paramets)

//2、教学问卷添加
export const reqQuesAdd = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/addName`, paramets, 'post')

//3、教学问卷添加小题
export const reqQuesAddTest = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/addTest`, paramets, 'post')

//4、教学问卷修改
export const reqQuesEdit = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/edit`, paramets, 'put')

//5、教学问卷修改题目
export const reqQuesTestEdit = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/editTest`, paramets, 'put')

//6、教学问卷删除题目
export const reqQuesTestDel = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/deleteTest`, paramets, 'delete')

//7、教学问卷批量删除
export const reqQuesDel = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/deleteBatch`, paramets, 'delete')

//8、教学问卷通过id查询
export const reqQuesDetail = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/getQuestionnairelist`, paramets)

//9、教学问卷试题上移
export const reqQuesMoveUp = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/MoveUp`, paramets, 'post')

//9、教学问卷试题下移
export const reqQuesMoveDown = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/MoveDown`, paramets, 'post')

//10、教学问卷通过id查询详情
export const reqQuesStatistics = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/getQuestionnairelist`, paramets)

//10、教学投票通过id查询详情
export const reqVoteStatistics = (paramets) => ajax(`/Questionnaire/JxInvestigationModel/listOptionsById`, paramets)

//10、获取学生其他选项及问答题答案
export const reqStudentAnswer = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/getStudentAnswer`, paramets)




// WEBPACK FOOTER //
// ./src/api/kzActivity/ques.js